export const LOCAL_VIDEO_WORKER_STATUS = Object.freeze({
    COMING_SOON: 'coming_soon',
});

export const LOCAL_VIDEO_WORKER_CAPABILITIES = Object.freeze([
    'native-ffmpeg-transcription',
    'native-keyframe-extraction',
    'low-resolution-proxy',
]);

export function getLocalVideoWorkerStatus() {
    return {
        available: false,
        status: LOCAL_VIDEO_WORKER_STATUS.COMING_SOON,
        engine: 'native-ffmpeg-worker',
        capabilities: [...LOCAL_VIDEO_WORKER_CAPABILITIES],
        message: 'Local native video processing is planned. Current builds keep originals as local sync-folder references and store evidence derivatives only.',
    };
}

export async function requestLocalVideoWorkerJob() {
    return {
        accepted: false,
        ...getLocalVideoWorkerStatus(),
    };
}
